import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import TabUI from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import React__default, { useState, useCallback, useEffect } from 'react';
import { Link } from '../../components/Link/Link.esm.js';

const useStyles = makeStyles(
  (theme) => ({
    tabsWrapper: {
      gridArea: "pageSubheader",
      backgroundColor: theme.palette.background.paper,
      paddingLeft: theme.spacing(3),
      minWidth: 0
    },
    defaultTab: {
      ...theme.typography.caption,
      padding: theme.spacing(3, 3),
      textTransform: "uppercase",
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.text.secondary
    },
    selected: {
      color: theme.palette.text.primary
    },
    tabRoot: {
      "&:hover": {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary
      }
    }
  }),
  { name: "BackstageHeaderTabs" }
);
function HeaderTabs(props) {
  const { tabs, onChange, selectedIndex } = props;
  const [selectedTab, setSelectedTab] = useState(selectedIndex ?? 0);
  const styles = useStyles();
  const handleChange = useCallback(
    (_, index) => {
      if (selectedIndex === void 0) {
        setSelectedTab(index);
      }
      if (onChange)
        onChange(index);
    },
    [selectedIndex, onChange]
  );
  useEffect(() => {
    if (selectedIndex !== void 0) {
      setSelectedTab(selectedIndex);
    }
  }, [selectedIndex]);
  function removeLeadingSlash(path) {
    return path.replace(/^\//, "");
  }
  return /* @__PURE__ */ React__default.createElement(Box, { className: styles.tabsWrapper }, /* @__PURE__ */ React__default.createElement(
    Tabs,
    {
      indicatorColor: "primary",
      textColor: "inherit",
      variant: "scrollable",
      scrollButtons: "auto",
      "aria-label": "tabs",
      onChange: handleChange,
      value: selectedTab
    },
    tabs.map((tab, index) => /* @__PURE__ */ React__default.createElement(
      TabUI,
      {
        "data-testid": `header-tab-${index}`,
        label: tab.label,
        key: tab.id,
        component: Link,
        to: removeLeadingSlash(tab.id),
        value: index,
        className: styles.defaultTab,
        classes: { selected: styles.selected, root: styles.tabRoot },
        ...tab.tabProps
      }
    ))
  ));
}

export { HeaderTabs };
//# sourceMappingURL=HeaderTabs.esm.js.map
